import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class TableModule extends Module {
  constructor(options) {
    super(options);

    this.DOMEl = options.element;

    this.titleContent = this.DOMEl.querySelector(".table-module__heading ");
    this.descriptionContent = this.DOMEl.querySelector(".table-module__description");
    this.TableGrid = this.DOMEl.querySelector(".table-module__grid");
    this.tableCards = this.DOMEl.querySelectorAll(".table-item__inner");

    this.timeline = gsap.timeline().pause();

    this.init();
  }

  init() {
    if(this.titleContent) this.timeline.to(this.titleContent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    if(this.descriptionContent) this.timeline.to(this.descriptionContent, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

    const triggerModuleAnimation = ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });

    const triggerExecutivesAnimation = ScrollTrigger.create({
      trigger: this.TableGrid,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.tableCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      },
      onEnterBack: ()=>{
        gsap.to(this.tableCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", stagger:0.2});
      }
    });
  }

}
